import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { Container } from 'react-bootstrap';
import Breadcrumbs from './Breadcrumbs';
import { LoadingContext } from './context/LoadingContext';
import { ToastContext } from './context/ToastContext';
import { Link } from 'react-router-dom';
import usePageNav from '../hooks/usePageNav';
import getNavigationInitialState from '../initialState/navigation';
import PageNav from './PageNav';
import AppContext from './context/AppContext';

const BrandList = () => {
    const [brandList, setBrandList] = useState([]);
    const { sendMessage } = useContext(ToastContext);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(0);
    const [pagesData, setPagesData] = useState(getNavigationInitialState());
    const containerRef = useRef(null);
    const {
        startLoading,
        finishLoading,
    } = useContext(LoadingContext);
    const { appContext } = useContext(AppContext);
    const appConfig = appContext.config.themeConfig;
    const fetchBrands = useCallback(async () => {
        try {
            startLoading();
            const url = new URL('/api/products/vendors/fullDetail', process.env.APP_URL);
            url.searchParams.set('page', page);
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                }
            });
            const { vendors, error, pageInfo } = await response.json();
            if (error) {
                sendMessage(error, 'danger');
            }
            if (vendors) {
                setBrandList(vendors);
            }
            if (pageInfo) {
                setPagesData({
                    limit: pageInfo.limitPerPage,
                    pages: pageInfo.totalPages,
                    count: pageInfo.totalObjects,
                });
            }
        } catch (e) {
            sendMessage(e.message, 'danger');
        } finally {
            finishLoading();
            setLoading(false);
        }
    }, [page]);

    useEffect(() => {
        fetchBrands();
    }, [fetchBrands]);

    const {
        curPage,
        generatedPagesData,
        paginateUser,
    } = usePageNav({
        containerRef,
        pagesData,
        initialCurPage: 0,
        onUpdate: (newPage) => setPage(newPage),
    });
    return (
        <Container
            className={'section'}
            style={{ padding: '0px 15px 30px' }}
            fluid>
            <div
                className={'mt-2'}></div>
            <Breadcrumbs
                breadcrumbList={[
                    [
                        'All Brands',
                        '/brands',
                    ]
                ]} />
            <div
                className={'d-flex gap-5 mt-2'}>
                <div
                    style={{
                        flexGrow: '1',
                    }}>
                    <h4
                        className={'m-0 p-0 mb-4 text-black'}>Brands</h4>
                    {loading && <div
                        className={'text-center'}>Loading...</div>}
                    <div
                        ref={containerRef}
                        className={'d-flex flex-wrap gap-3'}>
                        {brandList.map((brand, index) => (
                            <div
                                className={'border p-2'}
                                style={{
                                    width: '200px',
                                    height: '220px',
                                }}
                                key={`${brand.name}-${index}`}>
                                <Link
                                    to={`/brands/${brand}`}
                                    className={'custom-link d-flex flex-column align-items-center justify-content-between h-100'}>
                                    <img
                                        src={brand.imageUrl || appConfig.productNoImageUrl}
                                        alt={brand.name}
                                        className={'img-fluid'}
                                    />
                                    <span
                                        className={'fw-bold text-center'}>{brand.name}</span>
                                </Link>
                            </div>
                        ))}
                    </div>
                    <div
                        className={'mt-5'}>
                        <PageNav
                            enablePrevNextButton={true}
                            curPage={curPage}
                            totalPages={pagesData.pages}
                            generatedPagesData={generatedPagesData}
                            paginateUser={paginateUser}
                        />
                    </div>
                </div>
            </div>
        </Container >
    );
};

export default BrandList;